import ComplementaryItemsSection from '@pages/membership/membership-profiles/sections/ComplementaryItemsSection'
import EventParticipationsSection from '@pages/membership/membership-profiles/sections/EventParticipationsSection'
import FormAnswersSection from '@pages/membership/membership-profiles/sections/FormAnswersSection'
import ProfileActivitiesSection from '@pages/membership/membership-profiles/sections/ProfileActivitiesSection'
import SubscriptionActivitiesSection from '@pages/membership/membership-profiles/sections/SubscriptionActivitiesSection'
import SubscriptionSection from '@pages/membership/membership-profiles/sections/SubscriptionSection'
import { Navigate, RouteObject } from 'react-router-dom'

export const membershipProfileSectionRoutes: RouteObject[] = [
  { path: 'subscription', element: <SubscriptionSection /> },
  { path: 'event-participation', element: <EventParticipationsSection /> },
  { path: 'form-answers', element: <FormAnswersSection /> },
  { path: 'subscription-activities', element: <SubscriptionActivitiesSection /> },
  { path: 'profile-activities', element: <ProfileActivitiesSection /> },
  { path: 'complementary-items', element: <ComplementaryItemsSection /> },
  { index: true, element: <Navigate to="subscription" replace /> },
  { path: '*', element: <Navigate to="subscription" replace /> },
]
